<template>
  <div class="page-container content-430">
    <div class="row-line">
      <div
        class="click-btn-430 click-btn"
        @click="handleSelectClock"
      >
        设置教师打卡规则
      </div>
    </div>

    <div class="table-box">
      <Table
        ref="timeTable"
        border
        :loading="loadingClassTimeTable"
        :columns="classTableColumnShow"
        :data="classTableData"
        @on-selection-change="getListSelected"
      >
        <template slot="teaCheckInLimit" slot-scope="{ row }">
          <span>{{ limitNumShowObj[row.teaCheckInLimit] }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div>
            <span
              v-if="canOperateData"
              class="click-btn-430"
              @click="handleEdit(row)"
            >编辑</span>
            <span
              class="click-btn-430"
              @click="handleToDaySign(row.detailId)"
            >签到记录</span>
            <span class="click-btn-430" @click="handleOpenClockModal(row)">设置教师打卡规则</span>
            <span v-if="portOrg===0" class="click-btn-430" @click="handleOpenChangeDifferentClassDrawer(row)">节次转班\请假</span>
          </div>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        :page-size-opts="pageSizeOpts"
        show-total
        :current="pageInfo.pageNum"
        show-sizer
        class="page-right"
        @on-page-size-change="handlePageSize"
        @on-change="handlePageChange"
      ></Page>
    </div>
    <Modal
      v-model="ruleShow"
      title="打卡规则"
      :width="800"
      :footer-hide="true"
      :closable="false"
    >
      <Form ref="ruleForm" :model="ruleInfo">
        <FormItem label="打卡规则" prop="limitNumShow">
          <div class="form-tip-box">
            <RadioGroup v-model="ruleInfo.limitNumShow">
              <Radio :label="0">任课教师自由打卡</Radio>
              <Radio :label="1">仅支持1位教师打卡</Radio>
            </RadioGroup>
            <div class="form-tip">
              <span>自由排课每位教师都可以开始打卡考勤</span>
              <span>多名教师同时任教时，仅支持1名教师（先打卡为准）</span>
            </div>
          </div>
        </FormItem>
      </Form>
      <div class="btn-box">
        <Button :loading="ruleEditLoading" @click="ruleShow=false">取消</Button>
        <Button :loading="ruleEditLoading" type="primary" @click="handleSureClockRule">确定</Button>
      </div>
    </Modal>
    <UpdateClassDate
      ref="updateClassDateRef"
      :school-id="schoolId"
      :branch-id="branchId"
      :classroom-id="classroomId"
      :detail-id="editSelectRow.detailId"
      @on-submit-finish="onEditSubmitFinish"
    ></UpdateClassDate>
    <ChangeDifferentClassDrawer ref="changeDifferentClassDrawer" :school-id="schoolId" :classroom-id="classroomId"></ChangeDifferentClassDrawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import UpdateClassDate from '@pv/courseSchedulCenter/assets/components/UpdateClassDate.vue';
import { timeToStr, timeToYearStr } from '@/utils/utils.js';
import ChangeDifferentClassDrawer from './ChangeDifferentClassDrawer.vue';
// import ClassDetailInfo from './assets/components/ClassDetailInfo.vue';
export default {
  components: {
    // ClassDetailInfo,
    UpdateClassDate,
    ChangeDifferentClassDrawer
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    },
    branchId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    }
  },
  data() {
    // 课班详情状态 1未开课2已开课3已结课
    const courseDetailStateObj = {
      '1': '未开课',
      '2': '已开课',
      '3': '已结课',
      '4': '已停课'
    };
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      loadingClassTimeTable: false, // 是否加载班级课表数据
      classTableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '课次',
          key: 'classNo',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [`第${params.row.classNo}节`]);
          }
        },
        {
          title: '上课日期',
          key: 'classDate',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [`${timeToYearStr(params.row.classDate)}`]);
          }
        },
        {
          title: '上课时间',
          key: 'classTimeBegin',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              `${timeToStr(params.row.classTimeBegin)}-${timeToStr(
                params.row.classTimeEnd
              )}`
            ]);
          }
        },
        {
          title: '学生上课人数',
          key: 'studentTotal',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '上课地点',
          key: 'placeName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '授课老师',
          key: 'teacherDesc',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '状态',
          key: 'courseDetailState',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              `${courseDetailStateObj[params.row.courseDetailState]}`
            ]);
          }
        },
        {
          title: '教师打卡规则',
          slot: 'teaCheckInLimit',
          width: 150,
          align: 'center'
        }

      ], // 编辑课表列表表头
      classTableData: [], // 表格数据
      pageInfo: {
        total: 1,
        pageNum: 1,
        pageSize: 10
      },
      addInfo: {
        beginDate: null, // 开课日期
        beginTime: null // 上课时间
      },
      ruleAddInfo: {
        beginDate: [
          { required: true, message: '请输入开课日期', trigger: 'change' }
        ],
        beginTime: [
          {
            required: true,
            type: 'array',
            min: 2,
            message: '请输入上课时间',
            trigger: 'change'
          }
        ]
      },
      editShow: false, // 编辑弹窗是否展示
      editInfo: {
        placeId: '', // 上课场地的id
        beginDate: null, // 开课日期
        beginTime: null, // 上课时间
        teacher: [] // 授课老师
      },
      ruleEditInfo: {
        placeId: [
          { message: '请选择上课场地', trigger: 'blur' }
        ],
        beginDate: [
          { required: true, message: '请输入开课日期', trigger: 'change' }
        ],
        beginTime: [
          {
            required: true,
            type: 'array',
            min: 2,
            message: '请输入上课时间',
            trigger: 'change'
          }
        ],
        teacher: [
          { type: 'array', min: 1, message: '请选择授课老师', trigger: 'change' }
        ]
      },

      selectPlaceData: {}, // 选择的上课场地的信息
      // classroomId: '', // 班级id
      // branchId: '', // 校区id
      // schoolId: '', // 学校id
      providerId: '', // 学区
      editSelectRow: {},
      teacherColumn: [
        {
          title: '教师名称',
          key: 'userName',
          minWidth: 200
        },
        {
          title: '提供方',
          key: 'deptName',
          minWidth: 200
        },
        {
          title: '所属校区',
          key: 'schoolArea',
          minWidth: 200
        }
      ], // 教师列表表格column
      selectTeacherList: [], // 可以选择的教师列表
      teachersName: '',
      placeData: {},
      classLoading: false, // 添加或者编辑课次正在进行中
      ruleInfo: {
        limitNumShow: -1
      },
      limitNumShowObj: {
        0: '任课教师自由打卡',
        1: '仅支持1位教师打卡'
      },
      ruleShow: false,
      selectRuleDetailIds: [],
      ruleEditLoading: false,
      selectTable: []
    };
  },
  computed: {
    ...mapState(['userInfo']),

    // 是否可以操作数据(分端权限)
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if (this.portOrg === 0 || this.portOrg === 2) {
        return true;
      }
      return false;
    },
    classTableColumnShow() {
      if (this.portOrg === 0) {
        return [...this.classTableColumn, {
          title: '操作',
          slot: 'action',
          minWidth: 360,
          align: 'center',
          fixed: 'right'
        }];
      } else {
        return [...this.classTableColumn, {
          title: '操作',
          slot: 'action',
          minWidth: 260,
          align: 'center',
          fixed: 'right'
        }];
      }
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
  },
  mounted() {
    console.log('组件挂在---');
    this.getClassTimeTableList();
  },
  methods: {
    onEditSubmitFinish() {
      this.handlePageChange(1);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getClassTimeTableList();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getClassTimeTableList();
    },
    // 获取班级课表列表
    async getClassTimeTableList() {
      if (!this.classroomId) {
        this.$Message.error('缺少班级id');
        return;
      }
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        'condition.schoolId': this.schoolId,
        'condition.classroomId': this.classroomId
        // condition.schoolId:this.userInfo.orgId
      };
      // params.condition = JSON.stringify({ schoolId: this.userInfo.orgId });
      try {
        this.loadingClassTimeTable = true;
        const res = await courseSchedulCenter.getClassTimeTableApi(params);
        if (res.status === 200) {
          this.classTableData = res.message.list.map((item, index) => {
            // item.classNum = this.pageInfo.pageSize * (this.pageInfo.pageNum - 1) + (index + 1);
            const nameList = item.teachers.map(x => {
              return x.teacherName;
            });
            item.teacherDesc = nameList.join(',');
            return item;
          });
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingClassTimeTable = false;
      }
    },
    // 点击编辑按钮
    handleEdit(row) {
      this.editSelectRow = row;
      this.$refs.updateClassDateRef.handleOpen(row);
    },
    // 点击签到记录按钮
    handleToDaySign(detailId) {
      this.$emit('closeDrawer');
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_signRecord',
        query: {
          detailId
        }
      });
    },
    getListSelected(selection) {
      console.log(selection, '拿到的0---2342');
      this.selectTable = selection;
    },
    handleSelectClock() {
      if (this.selectTable.length === 0) {
        this.$Message.warning('请先选择要设置打卡规则的课次');
        return;
      }
      this.selectRuleDetailIds = this.selectTable.map(item => item.detailId);
      this.ruleInfo.limitNumShow = -1;
      this.ruleShow = true;
    },
    handleOpenClockModal(row) {
      this.selectRuleDetailIds = [row.detailId];
      this.ruleInfo.limitNumShow = +row.teaCheckInLimit;
      this.ruleShow = true;
    },
    async handleSureClockRule() {
      if (this.ruleInfo.limitNumShow === -1) {
        this.$Message.warning('请先选择打卡规则');
        return;
      }
      const params = this.selectRuleDetailIds.map(item => {
        return {
          detailId: item,
          limitNum: this.ruleInfo.limitNumShow
        };
      });
      this.ruleEditLoading = true;
      try {
        const res = await courseSchedulCenter.batchSetTeaCheckInLimitApi(params);
        if (res.status === 200) {
          this.$Message.success('设置成功');
          this.getClassTimeTableList();
          this.ruleShow = false;
        }
      } finally {
        this.ruleEditLoading = false;
      }
    },
    handleOpenChangeDifferentClassDrawer(row) {
      this.$nextTick(() => {
        this.$refs.changeDifferentClassDrawer.openDrawer(row);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.baseinfo {
  border: 1px solid #eee;
  border-radius: 10px 10px;
  .baseinfo-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.03);
    padding: 16px 24px;
    border-radius: 10px 10px 0 0;
    .base-left {
      display: flex;
      align-items: center;
      .base-name {
        font-weight: bold;
        font-size: 14px;
      }
      span + span {
        margin-left: 8px;
      }
    }
  }
}
.table-box {
  margin-top: 24px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 16px;
  }
}
.form-tip-box{
  label+label{
    margin-left: 200px;
  }
  .form-tip{
    color: #999;
    font-size: 12px;
    span+span{
      margin-left: 100px;
    }
  }

}
.row-line{
  display: flex;
  justify-content: flex-end;
}
.gray-font{
  color: #999;
}
</style>
